import { lazy } from "react";

/* Code-split deploy resilience. After a deploy, hashed chunk filenames change and
   the old ones 404, so a tab still running the previous build throws "Failed to
   fetch dynamically imported module" when it lazy-loads a route. We recover by
   reloading once to fetch the fresh index.html + chunks. A short time-guard
   prevents a reload loop if the new build is genuinely broken. */
export function shouldReloadForChunkError() {
  try {
    const k = "byb.chunkReloadAt";
    const last = Number(sessionStorage.getItem(k) || 0);
    if (Date.now() - last < 15000) return false; // already reloaded just now
    sessionStorage.setItem(k, String(Date.now()));
    return true;
  } catch {
    return true;
  }
}

export function lazyWithReload(factory) {
  return lazy(() =>
    factory().catch((err) => {
      if (shouldReloadForChunkError()) {
        window.location.reload();
        return new Promise(() => {}); // hang the import while the page reloads
      }
      throw err; // second failure → let the ErrorBoundary show
    }),
  );
}
